export const enErrors = {
	"http-login-error": "Can't connect to the server",
	"E-4": "You are not authorized to use the application",
};
